import { ReqSucResult, ReqErrResult, LoginInfo, LoginType, WebLoginMode } from '../types';
import Cookies, { CookieAttributes } from 'js-cookie';
import JsApi from '@tencent/tvf-jsapi';
import { BridgeErrorCodeValue } from '@tencent/tvf-jsapi/lib/umd/src/helper';

export const loadScript = (url: string, needRemove = true) => new Promise((resolve) => {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = url;
  script.onload = () => {
    needRemove && document.body.removeChild(script);
    resolve(true);
  };
  script.onerror = () => {
    needRemove && document.body.removeChild(script);
    resolve(false);
  };
  document.body.appendChild(script);
});

export const handleSuccess = <T>(result: T): ReqSucResult<T> => ({
  errCode: 0,
  errMsg: '',
  result,
});

export const handleError = (errCode: -1 | BridgeErrorCodeValue, errMsg: string): ReqErrResult<null> => ({
  errCode,
  errMsg,
  result: null,
});

export const time33 = (str: string) => {
  let hash = 5381;
  for (let i = 0, len = str.length; i < len; i++) {
    hash += (hash << 5) + str.charCodeAt(i);
  }
  hash = hash & 0x7fffffff;

  return hash;
};

/**
 * @param cookie: jsapi 返回的对象，优先取这取，取不到就从 document.cookie 中取
 */
export const getCookie = (name: string, cookie: Record<string, string> = {}) => cookie[name] || Cookies.get(name) || '';
export const setCookie = (name: string, value: string, options?: CookieAttributes) => Cookies.set(name, value, options);

export const stringify = (obj: Record<string, any>) => Object.keys(obj)
  .map(key => `${key}=${encodeURIComponent(obj[key])}`)
  .join('&');

export const sleep = (time: number) => new Promise((resolve) => {
  setTimeout(resolve, time);
});

/**
 * 获取登录信息，cookie
 * @param isInApp 是否在端内
 * @param loginInfoHandler 提供给外部端往 loginInfo 设置不同的字段
 */
export const getLoginInfo = async ({
  isInApp,
  loginInfoHandler,
}: {
  isInApp: boolean;
  loginInfoHandler: (loginInfo: LoginInfo, appCookies: Record<string, string>) => void;
}) => {
  const loginInfo: LoginInfo = {
    type: LoginType.nologin,
  };
  const appCookies: Record<string, string> = {}; // 用来保存端内场景通过 jsapi 获取到的 cookie 对象

  // 端内
  if (isInApp) {
    try {
      const { errCode, errMsg, result } = await JsApi.invoke('getMainCookie');
      if (errCode !== 0) {
        return handleError(errCode, errMsg);
      }

      const { type, cookie } = result;
      Object.assign(appCookies, cookie);
      if (type === 'qq') {
        loginInfo.type = LoginType.qq;
      } else if (type === 'wx') {
        loginInfo.type = LoginType.wx;
      } else if (type === 'phone') {
        loginInfo.type = LoginType.phone;
      }
    } catch (error) {
      // do nothing
    }
  } else {
    // 微视下通过 iAuthType 区分登录类型
    // 应用宝下通过 yyb_logintype 区分登录类型
    // 腾讯动漫端外只有qq且通过 login_type 为 4
    if (
      getCookie('main_login') === 'qq'
      || getCookie('iAuthType') === '1'
      || getCookie('yyb_logintype') === 'qq'
      || getCookie('login_type') === '4'
    ) {
      loginInfo.type = LoginType.qq;
    } else if (
      getCookie('main_login') === 'wx'
      || getCookie('iAuthType') === '3'
      || getCookie('yyb_logintype') === 'wx'
    ) {
      loginInfo.type = LoginType.wx;
    }
  }

  if (loginInfo.type === LoginType.nologin) {
    return handleError(-1, '当前未登录，无法获取登录态');
  }

  // 外部给 loginInfo 设置不同的字段
  loginInfoHandler(loginInfo, appCookies);

  return handleSuccess(loginInfo);
};

/**
 * 登录页
 */

// 独立的登录页
// eslint-disable-next-line
// export const getTenvideoLoginMiddlePage = (webLoginMode?: WebLoginMode) => `//s.iwan.qq.com/login-page/video.html?web_login_mode=${webLoginMode || ''}&redirect_url=${encodeURIComponent(window.location.href)}`;

// 爱玩登录页
// eslint-disable-next-line
export const getTenvideoLoginMiddlePage = (webLoginMode?: WebLoginMode) => `//iwan.qq.com/m/login/login-qt.htm?ru=${encodeURIComponent(window.location.href)}`;
export const getWeishiLoginMiddlePage = () => `//h5.weishi.qq.com/weishi/account/login?r_url=${encodeURIComponent(window.location.href)}`;
export const getSportsLoginMiddlePage = () => `https://m.sports.qq.com/pages-for-third-party/h5-login.htm?rurl=${encodeURIComponent(window.location.href)}`;
export const getYybLoginMiddlePage = (webLoginMode?: WebLoginMode) => `//s.iwan.yyb.qq.com/login-page/yyb.html?web_login_mode=${webLoginMode || ''}&redirect_url=${encodeURIComponent(window.location.href)}`;

export const safeJsonParse = <T>(data: string): T | null => {
  try {
    return JSON.parse(data);
  } catch (error) {
    return null;
  }
};
